import React from 'react'
import { Skeleton} from 'antd'
import styles from './SkelentonCardSubject.module.scss'
const SkelentonCardSubject = ({ count }) => {
  const getMock = () => {
    const card = []
    const limit = count ? count : 14
    let i = 0
    while (i < limit) {
      card.push(i++)
    }
    return card
  }
  
  return(
    <div className = {styles.rootSkeleton}>
      {
        getMock().map((r,i)=>{
          return(
            <div className = {styles.rootRegtangle} key = {i}>
              <Skeleton.Image active className={styles.imgActive}/>
            </div>
          )
        })
      }
    </div>
  )
}
export default SkelentonCardSubject